import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import i18next from 'i18next';
export default class LoadingCircle extends Component {
    render() {
        const { size, children, text, color = 'gray-500', textColor, dataTestId } = this.props;
        const className = classnames({
            fa: true,
            'fa-circle-o-notch': true,
            'fa-spin': true,
            [`fa-${size}x`]: true,
            [`text-${color}`]: true,
        });
        const textClassName = classnames({
            [`text-${textColor}`]: true,
        });
        return (React.createElement("div", { "data-testid": dataTestId, className: "flex items-center" },
            React.createElement("i", { "data-testid": "i-eff659ae", className: className, "aria-hidden": "true" }),
            React.createElement("span", { "data-testid": "span-a6ed4d16", className: textClassName }, children || text)));
    }
}
LoadingCircle.propTypes = {
    size: PropTypes.oneOf([1, 2, 3, 4, 5]),
    text: PropTypes.string,
    color: PropTypes.string,
    textColor: PropTypes.string,
    children: PropTypes.oneOfType([
        PropTypes.node,
        PropTypes.arrayOf(PropTypes.node),
    ]),
};
LoadingCircle.defaultProps = {
    size: 1,
    text: i18next.t('LOADING'),
    color: 'black',
    textColor: 'black',
};
